<template>
  <div class="steps">
    <span class="line"></span>
    <p v-for="(item, index) in data" class="row"  :class="{active: step > index}" :key="index">
      <span class="step">
        <img :src="item.src" alt="" />
      </span>
      <span class="name">{{item.name}}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    step: [String, Number],
    data: Array
  }
}
</script>

<style lang="less" scoped>
.steps{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 110px;
  position: relative;

  .line{
    position: absolute;
    width: calc(100% - 284px);
    height: 2px;
    background-color: #e0e0e0;
    top: 50px;
  }

  .row{
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
    background-color: white;
    padding: 0px 30px;

    &.active{
      .step{
        background-color: #1e6dd6;
      }
    }

    .step{
      width: 64px;
      height: 64px;
      background-color: #c4c4c4;
      border-radius: 50%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    .name{
      font-size: 15px;
      font-family: PingFang;
      line-height: 15px;
      color: #999999;
      margin-top: 10px;
    }
  }
}
</style>
